import { AuthProtectedRoute } from "common/components";
import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";

import Login from "./Login";
import Register from "./Register";

export const AuthenticationRouter = () => {
  let match = useRouteMatch();

  return (
    <Switch>
      <AuthProtectedRoute
        path={`${match.url}/register`}
        component={Register}
        reverseLogic={true}
      />

      <AuthProtectedRoute
        path={`${match.url}/login`}
        component={Login}
        reverseLogic={true}
      />

      <AuthProtectedRoute
        path={`${match.url}`}
        component={Login}
        reverseLogic={true}
      />
    </Switch>
  );
};
